import React from "react";
import { UserCog } from "lucide-react";
import {
  isTestIdentitySwitchAllowed,
  resetGuestIdentityForTesting,
} from "@core/lib/guestIdentityService";

/**
 * Bouton discret pour tester plusieurs "personnes" invitées dans le même
 * navigateur (preview Vercel, local) sans profils navigateur séparés —
 * efface l'identité locale (fingerprint, device id, jeton de possession) et
 * recharge la page. Ne rend rien sur les domaines de prod
 * (isTestIdentitySwitchAllowed) : aucune vérification serveur, aucun effet
 * sur les autres utilisateurs, juste un confort de test.
 */
export function TestIdentitySwitcher() {
  if (!isTestIdentitySwitchAllowed()) return null;

  const handleClick = () => {
    if (
      !window.confirm(
        "Réinitialiser l'identité de ce navigateur ? Vous ne serez plus reconnu comme l'auteur de vos votes/sondages précédents (rien n'est supprimé côté serveur).",
      )
    ) {
      return;
    }
    resetGuestIdentityForTesting();
    window.location.reload();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="test-identity-switcher"
      title="Test only — réinitialise l'identité invité de ce navigateur (non visible en prod)"
      className="fixed bottom-3 right-3 z-[9999] flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-950/90 px-3 py-1.5 text-[11px] font-medium text-amber-400 shadow-lg backdrop-blur hover:bg-amber-900"
    >
      <UserCog className="h-3.5 w-3.5" />
      Nouvelle identité (test)
    </button>
  );
}
